export default __webpack_public_path__ + "af2f96023e8a152accd29581e87ba138.png";